// (A) 중립 Tag API — antd 미접촉. (B) PlainTag 에 위임(순수 시각).
import type { CSSProperties, ReactNode } from 'react'
import { PlainTag } from '../_impl/PlainTag'

export interface OmwTagProps {
  /** 실측: EMLPreview 가 icon 슬롯 사용. */
  icon?: ReactNode
  color?: string
  className?: string
  style?: CSSProperties
  children?: ReactNode
}

export function OmwTag(props: OmwTagProps) {
  return <PlainTag {...props} />
}
